import React, { useState, useEffect } from 'react';
import { fetchEvents } from '../api/api';
import { createSlug } from '../utils/slugUtils';
import { useCustomNavigation } from '../components/NavigationContext';
import styles from '../styles/components/_EventListAlpha.module.scss';

const EventListAlpha = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const { customNavigate } = useCustomNavigation();

    const decodeHtmlEntities = (text) => {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        return textarea.value;
    };

    const sortedEvents = events.sort((a, b) => {
        const titleA = typeof a.title === 'object' ? decodeHtmlEntities(a.title.rendered) : decodeHtmlEntities(a.title);
        const titleB = typeof b.title === 'object' ? decodeHtmlEntities(b.title.rendered) : decodeHtmlEntities(b.title);
        return titleA.localeCompare(titleB, 'fr');
    });

    useEffect(() => {
        const loadEvents = async () => {
            try {
                const eventData = await fetchEvents();
                const sortedEvents = eventData.sort((a, b) => {
                    const titleA = typeof a.title === 'object' ? decodeHtmlEntities(a.title.rendered) : decodeHtmlEntities(a.title);
                    const titleB = typeof b.title === 'object' ? decodeHtmlEntities(b.title.rendered) : decodeHtmlEntities(b.title);
                    return titleA.localeCompare(titleB, 'fr');
                });
                setEvents(sortedEvents);
            } catch (error) {
                console.error('Erreur lors du chargement des événements:', error);
            } finally {
                setLoading(false);
            }
        };
        loadEvents();

    }, []);

    const handleCardClick = (event) => {
        if (!event || !event.title) {
            console.warn("Données manquantes pour l'événement", event);
            return;
        }

        const eventTitle = typeof event.title === 'object' ? event.title.rendered : event.title;
        const slug = createSlug(eventTitle, event);

        if (!slug) {
            console.warn("Impossible de créer un slug valide pour l'événement:", eventTitle);
            return;
        }

        customNavigate(`/programmation/${slug}`, {
            state: { eventData: event },
            replace: true
        });
    };

    if (loading) return <div className={styles.loading}>Chargement...</div>;

    return (
        <div className={styles.eventListAlpha}>
            <div className={styles.header}>
                <h1>PROGRAMMATION</h1>
            </div>
            {sortedEvents.map((event, index) => {
                const title = typeof event.title === 'object' ? decodeHtmlEntities(event.title.rendered) : decodeHtmlEntities(event.title);
                return (
                    <h4
                        key={event.id}
                        className={`${styles.eventTitle} ${index % 2 === 0 ? styles.even : styles.odd}`}
                        onClick={() => handleCardClick(event)}
                    >
                        {title}
                    </h4>
                );
            })}
        </div>
    );
};

export default EventListAlpha;